<template>
    <div class="member">
    <h1 class="title has-text-left has-text-weight-light ">MEMBER</h1>
        <p class="subtitle has-text-left">MEMBER</p>
        <div class="mems columns  is-multiline is-mobile">
            <mem v-for="member in returnmembers(members)" v-bind:key="member.id" v-bind:text="member.text" v-bind:src="member.src" v-bind:name="member.name" v-bind:twitter="member.twitter"></mem>
        </div>
        <p class="subtitle has-text-left">OB</p>
        <div class="mems columns  is-multiline is-mobile">
            <mem v-for="member in returnOBs(members)" v-bind:key="member.id" v-bind:text="member.text" v-bind:src="member.src" v-bind:name="member.name" v-bind:twitter="member.twitter"></mem>
        </div>
    </div>
</template>

<script>
    import mem from "../components/mem";
    export default {
        name: "MEMBER",
        components: {mem},
        data(){
            return{
                members:[


                    {id:2,name:"いしひら",text:"\"YouTubeやniconicoに耳コピ動画などを投稿してます \n" +
                            "■YouTube　https://www.youtube.com/channel/UCMgQhT6XJt4v8jUO41GHGXQ\n" +
                            "■niconico　https://www.nicovideo.jp/user/18539220\"",twitter:"ishihira_",src:"/img/mem/いしひら.jpeg",OB:'true'},
                    {id:3,name:"黒鞄",text:"曲を出さない隠居陰キャです。個人(?)では/// -triple slash-っていう宗教団体をやってます。裏垢女子は連絡ください。",twitter:"kuro__kaban",src:"/img/mem/高畑俊作.jpeg",OB:'true'},
                    {id:4,name:"inphey",text:"アニメとtranceが好きな大学院生です。よろしくお願いします。",twitter:"iPhantasmagoria",src:"/img/mem/みりあ赤城.png",OB:'true'},
                    {id:5,name:"サイコドラゴン先生",text:"自主制作アニメを作りつつ、その劇中曲も作っている人です。",twitter:"MisterPDragon",src:"/img/mem/レモンマン.PNG",OB:'true'},
                    {id:6,name:"krang.",text:"ハウス、トランス、ドラムンベース、グリッチホップなどを嗜んでおります",twitter:"krangb",src:"/img/mem/krang.jpeg",OB:'true'},
                    {id:7,name:"issun",text:"Aeニモマケズ、イラレニモマケズ、blenderニモphotoshopニモマケヌ。",twitter:"sana_natori",src:"/img/mem/Tイッスン.jpg",OB:'true'},

                    {id:8,name:"AlnoughX",text:"Seven Lions とか Au5 みたいになりてぇ… ",twitter:"Krono_s1368",src:"/img/mem/AlnoughX.png",OB:'true'},
                    {id:9,name:"Marmot",text:' 音街ウナでボカロ曲を作ってます',twitter:"MarmotMusic",src:'/img/mem/Marmot.jpg',OB:'false'},
                    {id:10,name:"Kilvove",text:"主にProgressive HouseやFuture Bounce等のEDMを作っています",twitter:"Kilvove",src:"/img/mem/Kikvove.png",OB:'false'},
                    {id:11,name:"Amohs ",text:"「僕はEDMが好きだ。こればかりは譲れない。」そう言い放ったアモーの目は真剣そのものだった。",twitter:"cyromall",src:"/img/mem/Kilvove.jpeg",OB:'false'},
                    {id:12,name:"axent",text:"漫画と食事が好き。",twitter:"ax_ent",src:"/img/mem/axent.png",OB:'false'},
                    {id:13,name:"Tsubaki",text:"虚無食って生きてます。",twitter:"",src:"/img/mem/tubaki.jpeg",OB:'false'},
                    {id:14,name:"のぶあき(仮名)",text:"画像作ったりwebサイトを作ったりする。",twitter:"sobautinobuaki",src:"/img/mem/nobu.JPG",OB:"false"},
                    {id:15,name:"Clarine",text:"ConCreateサークル長/締め切りが苦手です。",twitter:"luxy_k27",src:"/img/mem/Clarine.jpeg",OB:'false'},
                    {id:16,name:"TAKA",text:"ボカロ曲を作ってます。",twitter:"taka1225_Bass",src:"/img/mem/T.png",OB:'false'},
                    {id:17,name:"Master",text:"ボカロや、いろいろな音楽に挑戦しています。",twitter:"",src:"/img/mem/master.jpg",OB:'false'},
                    {id:18,name:"チャーハンマスターあゆむ",text:"好きなジャンル:ヘヴィメタル,ニュー・ミュージック,エレクトロ・ポップ,鬱系黒人ラップ\n"+
                            "趣味・特技:読書,見ず知らずのお年寄りや子供から突然話しかけられやすい\n" +
                            "最後に一言:健全で普通などこにでもいる大学生です。よろしくどうぞ。\"",twitter:"chahan_master",src:"/img/mem/WeAre.jpeg",OB:'false'}

                ]
            }
        },
        methods:{
            returnmembers :function (members) {
                return members.filter((v)=>(v.OB=="false"));
            },
            returnOBs:function (members) {
                return members.filter((v)=>(v.OB=="true"));
            }
        }
    }
</script>

<style scoped>
.mems{
    margin-left: 10px;
}
p{
    margin-left: 20px;
}
    .title{
        margin-bottom: 40px;
    }
.subtitle{
    margin-bottom: 0;
    padding-bottom: 20px;
    font-size: 24px;
}
</style>